import PendingOrdersModal from './PendingOrdersModal';
import EmailQuoteModal from './EmailQuoteModal/EmailQuoteModal';

export {
  PendingOrdersModal,
  EmailQuoteModal,
};

export const pricingModals = {
  EMAIL_QUOTE_MODAL: EmailQuoteModal,
};
